import React from 'react';
import { Header } from './Header';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <main className="relative flex flex-col min-h-screen w-full overflow-x-hidden bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50" data-id="element-117">
      <Header data-id="element-118" />
      <div className="relative z-10 flex-1" data-id="element-119">{children}</div>

      {/* Footer - Pinned to very bottom */}
      <footer className="w-full py-6 bg-white border-t-4 border-gray-800 mt-auto" data-id="element-120">
        <div className="w-full px-4" data-id="element-121">
          <div className="flex items-center justify-center" data-id="element-122">
            <p className="text-gray-600 font-medium text-sm tracking-wide" data-id="element-123">
              © 2026 HorizonIMA. All Rights Reserved.
            </p>
            <div className="ml-4 flex gap-2" data-id="element-124">
              <div className="w-3 h-3 rounded-full bg-coral-500" data-id="element-125" />
              <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-126" />
              <div className="w-3 h-3 rounded-full bg-purple-400" data-id="element-127" />
            </div>
          </div>
        </div>
      </footer>
    </main>;
}